<template>
  <form class="form-horizontal">
    <div class="form-group">
      <label class="col-xs-2 control-label">
        标题
      </label>
      <div class="col-xs-10">
        <input type="text" class="form-control" v-model="route.basic.highlightTitle">
      </div>
    </div>
    <div v-for="item in route.routeHighlight" class="ng-scope">
      <div class="page-header ng-binding"><span class="glyphicon glyphicon-paperclip"></span> 亮点 {{$index + 1}} <button type="button" class="close" @click="route.routeHighlight.$remove(item)">&times;</button></div>
      <div class="form-group">
        <div class="col-xs-2">
          <d-upload :url.sync="item.pic" class="btn btn-primary btn-block btn-xs">上传图片 16:9</d-upload>
          <img class="img-responsive ng-hide" style="margin-top: 5px;" v-show="item.pic" :src="item.pic">
        </div>
        <div class="col-xs-10">
          <input class="form-control" type="text" v-model="item.title">
          <!-- <textarea class="form-control" rows="4" style="margin-top: 10px;" v-model="item.intro" placeholder="亮点详情"></textarea> -->
          <d-editor :content.sync="item.intro" style="margin-top: 10px;"></d-editor>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="col-xs-12 text-center">
        <button type="button" class="btn btn-default" @click="route.routeHighlight.push({
          intro: '',
          pic: '',
          title: ''
        })">添加</button>
      </div>
    </div>
    <div class="form-group">
      <div class="col-xs-12 text-center">
        <button type="button" @click="click(submit)($event)" class="btn btn-primary">保存</button>
        <button type="button" @click="click(submit)($event, '/route/' + $route.params.id + '/notice')" class="btn btn-success">保存并下一步</button>
      </div>
    </div>
  </form>
</template>

<script>
  import dEditor from '../../components/Editor'
  import config from '../../libs/config'
  import utils from '../../libs/utils'
  import dUpload from '../../components/Upload'

  export default {
    components: {
      dEditor,
      dUpload
    },
    props: ['route'],
    methods: {
      submit (next) {
        let routeHighlights = this.route.routeHighlight.map(({intro, pic, title}) => {
          return {
            intro,
            pic,
            title
          }
        })
        let data = {
          highlightTitle: this.route.basic.highlightTitle,
          routeHighlights
        }

        return this.$http.put(`${config.apiWe}/product/route/${this.$route.params.id}/highlight`, data)
          .then(() => {
            next && this.$route.router.go(next)
          })
      },
      click: utils.click
    }
  }
</script>



/** WEBPACK FOOTER **
 ** Focus.vue?312eaedf
 **/